"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterJourneyResults = exports.castAsJourney = exports.checkIfJourneryResults = void 0;
var filterPlainResults_1 = require("./filterPlainResults");
var journeyProperty = "journeys";
var checkIfJourneryResults = function (appliedFiltersValues) {
    return appliedFiltersValues.some(function (_a) {
        var path = _a.path;
        return path.includes(journeyProperty);
    });
};
exports.checkIfJourneryResults = checkIfJourneryResults;
function castAsJourney(item) {
    if (!(journeyProperty in item))
        return null;
    var validItem = item;
    var propertyValues = validItem[journeyProperty];
    return propertyValues;
}
exports.castAsJourney = castAsJourney;
function removePropertyFromPath(appliedFiltersValues, journeyProperty) {
    return appliedFiltersValues.map(function (item) {
        var path = item.path
            .split(".")
            .filter(function (property) { return property !== journeyProperty; })
            .join(".");
        return __assign(__assign({}, item), { path: path });
    });
}
function generateJourneysFiltersDictionary(appliedFiltersValues, journeyProperty) {
    var removedJourneyProperty = removePropertyFromPath(appliedFiltersValues, journeyProperty);
    return removedJourneyProperty.reduce(function (dictionary, filterValue) {
        var _a = filterValue.path.split("."), index = _a[0], restOfPath = _a.slice(1);
        var path = restOfPath.join(".");
        if (!dictionary[index]) {
            dictionary[index] = [];
        }
        dictionary[index].push(__assign(__assign({}, filterValue), { path: path }));
        return dictionary;
    }, {});
}
function filterJourneyResults(results, appliedFiltersValues) {
    var _a;
    var filteredResults = [];
    for (var i = 0; i < results.length; i++) {
        var shouldFilterSolition = false;
        var newList = [];
        var solution = results[i];
        var validJourneySolution = castAsJourney(solution);
        if (!validJourneySolution) {
            shouldFilterSolition = true;
            continue;
        }
        var journeysFiltersDictionary = generateJourneysFiltersDictionary(appliedFiltersValues, journeyProperty);
        for (var j = 0; j < validJourneySolution.length; j++) {
            var journeySegment = validJourneySolution[j];
            var filterValues = journeysFiltersDictionary[j];
            if (!filterValues) {
                newList.push(journeySegment);
                continue;
            }
            var filteredJourneySegment = (0, filterPlainResults_1.filterPlainResults)(journeySegment, filterValues);
            if (!filteredJourneySegment.length) {
                shouldFilterSolition = true;
                continue;
            }
            newList.push(filteredJourneySegment);
        }
        if (shouldFilterSolition) {
            continue;
        }
        var filteredSolution = __assign(__assign({}, solution), (_a = {}, _a[journeyProperty] = newList, _a));
        filteredResults.push(filteredSolution);
    }
    return filteredResults;
}
exports.filterJourneyResults = filterJourneyResults;
//# sourceMappingURL=filterJourneyResults.js.map